/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withRouter } from 'react-router-dom';
import {
    object, bool, func, string, shape, number, array,
} from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import Paper from '@material-ui/core/Paper';
import ReactHtmlParser from 'react-html-parser';

import { actions as tagManagerActions } from '../../../../../../../../state/ducks/TagManager';
import { getIsPassportUserLoggedIn } from '../../../../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import { getPassportBundleItemCurrentlyInCart, getPassportHoldoutStatus, getSSRDeviceType } from '../../../../../../../../state/ducks/App/App-Selectors';
import isPassportEnrollmentActive from '../../../../../../../helpers/passportEnrollmentVisibility';

import PassportCardWithCheckbox from '../Partials/PassportCardWithCheckbox/PassportCardWithCheckbox';
import PassportTncModal from '../Partials/PassportTnCModal/PassportTnCModal';
import AddPassportConsent from '../Partials/AddPassportModal/AddPassportModal';
import PassportLearnMoreModal from '../Partials/PassportLearnMoreModal/PassportLearnMoreModal';
import EventDispatcher from '../../../../../../Account/state/reducers/EventDispatcher';
import {
    getCartOrderDetails,
    getPassportSignInData,
    getPassportSubscriptionStatus,
    getPassportBannerStatus,
    getStatusOfPassportApplyRmGC,
    getIsPassportCapPriceReached,
    getPassportData,
    getCartCount,
    getOrderContainsSubscriptionItem,
    getOrderTotalSummary,
    getRecipientAddress,
    getUserProfile,
} from '../../../../../../../../state/ducks/Common/Common-Selectors';

import { clearErrors } from '../../../../../../../../state/ducks/Common/ducks/Error/Error-Actions';
import { getFeatureFlags, getPresentationFamily  } from '../../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const styles = (theme) => ({
    passPortCard: {
        padding: '5px 20px',
    },
    passportBanner: {
        width: '100%',
    },
    passportDesc: {
        fontSize: '13px',
        color: theme?.palette?.black,
        lineHeight: '20px',
        marginTop: '20px',
        marginRight: '10px',
        [theme?.breakpoints?.down('md')]: {
            marginLeft: 10,
        },
    },
    marginBottom: {
        marginBottom: '36px',
        [theme?.breakpoints?.down('md')]: {
            marginBottom: 10,
        },
    },
    root: {
        boxSizing: 'border-box',
        padding: 0,
        color: theme?.palette?.black,
        fontSize: '18px',
        overflow: 'hidden',
        transition: 'height 0.2s ease-in-out 0.0s',
    },
    rootFood: {
        width: '100%',
        height: 'auto',
        // Mobile
        [theme.breakpoints.down('md')]: {
            width: '100%',
        },
    },
    rootFoodPassportMember: {
        width: '352px',
        height: '67px',
    },
    rootPay: {
        boxSizing: 'border-box',
        padding: 0,
        color: theme?.palette?.black,
        backgroundColor: 'transparent',
        fontSize: '16px',
        overflow: 'hidden',
        transition: 'height 0.2s ease-in-out 0.0s',
        boxShadow: 'none',
        width: '100%',
        '& $passportDesc': {
            fontSize: '14px',
            marginLeft: '10px',
        },
        '& $passPortCard': {
            margin: 0,
            padding: 0,
        },
        '& $checkbox': {
            padding: '16px 0',
        },
        '&$rootFoodPassportPayment': {
            width: '250px',
            paddingRight: '8px',
            height: 'auto',
            '& $passportDesc': {
                padding: '0 10px',
                marginTop: '5px',
                textAlign: 'left',

            },
            [theme.breakpoints.only('xs')]: {
                width: 'calc(100% - 8px)',
                margin: '0 auto',
            },
            [theme.breakpoints.only('sm')]: {
                width: 400,
            },
        },
    },
    rootFoodPassportPayment: {},
    checkbox: {
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        padding: '16px 11px',
        '&$checked': {
            color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        },
    },
    checked: {
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        '&$checked': {
            color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        },
    },
    '@keyframes stroke': {
        '100%': {
            strokeDashoffset: '0',
        },
    },
    '@keyframes scale': {
        '0%, 100%': {
            transform: 'none',
        },
        '50%': {
            transform: 'scale3d(1.1, 1.1, 1)',
        },
    },
    '@keyframes fill': {
        '100%': {
            boxShadow: `inset 0px 0px 0px 40px ${theme?.palette?.primaryButton}`,
        },
    },
    checkmarkCircle: {
        strokeDasharray: '166',
        strokeDashoffset: '166',
        strokeWidth: '2',
        strokeMiterlimit: '10',
        stroke: theme?.palette?.primaryButton,
        fill: 'none',
        animation: '$stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards',
    },
    checkmark: {
        width: '30px',
        height: '30px',
        borderRadius: '50%',
        display: 'inline-block',
        strokeWidth: 4,
        stroke: theme?.palette?.white,
        strokeMiterlimit: '10',
        margin: '14px 5px 14px 0',
        verticalAlign: 'middle',
        boxShadow: `inset 0px 0px 0px ${theme?.palette?.primaryButton}`,
        animation: '$fill .4s ease-in-out .4s forwards, $scale .3s ease-in-out .9s both',
    },
    checkmarkCheck: {
        transformOrigin: '50% 50%',
        strokeDasharray: '38',
        strokeDashoffset: '5',
        animation: '$stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards',
    },
    passportMemberImage: {
        width: '352px',
        height: '67px',
    },
    passportContainer: {
        '& $root': {
            width: 'calc(100% - 32px)',
            margin: '0px auto 16px auto',
            padding: '11px 0px 20px',
            backgroundColor: '#fafafa',
            boxShadow: 'none',
            border: '0px',
            [theme.breakpoints.up('600')]: {
                width: '100%',
                padding: '20px 0px 20px',
            },
        },
        '& $passportDesc': {
            fontSize: '12px',
            lineHeight: '22px',
            marginLeft: '12px',
            [theme.breakpoints.up('600')]: {
                fontSize: '14px',
                lineHeight: '24px',
            },
        },
        '& $checkmark': {
            width: '24px',
            height: '24px',
        },
        '& $passPortCard': {
            padding: '5px 16px',
        },
        '& $checkWrapper': {
            maxWidth: '28px',
            marginLeft: '8px',
            [theme.breakpoints.down('600')]: {
                marginLeft: '0',
            },
        },
    },
    checkWrapper: {},

    pdpShortStyle: {
        '& $root': {
            margin: '0 auto 0px',
            padding: '7px 0px',
            backgroundColor: '#fafafa',
            [theme.breakpoints.up('600')]: {
                padding: '16px 0px',
            },
        },
        '& $passportDesc': {
            fontSize: '14px',
        },
    },
    pdpAtcModuleContainer: {
        '& $root': {
            backgroundColor: theme.palette.white,
        },
    },
    plaWrapperReskin: {
        [theme.breakpoints.down('600')]: {
            '& $root': {
                width: '100%',
            },
        },
    },
});

class PassportBannerUI extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayLearnMore: false,
            displayPassportTnc: false,
            displayPassport: true,
        };
    }

    componentDidMount() {
        const { callClearErrors, fetchUserProfile } = this.props;
        fetchUserProfile();
        callClearErrors({ errType: 'passport' });
        this.togglePassport();
    }

    componentDidUpdate(prevProps) {
        const { history, isInPassportHoldout } = this.props;
        // if passport holdout group refresh
        if (prevProps.isInPassportHoldout !== isInPassportHoldout) {
            history.go();
        }
    }

    getEligibleProduct = () => {
        const { productsById, selectedProductSku } = this.props;
        if (productsById && selectedProductSku && Object.keys(productsById).length > 0) {
            const selectedProduct = productsById[selectedProductSku];
            const { x_primefreeshipflag: freeShipping } = selectedProduct;
            if (freeShipping === 'N') return false;
        }
        return true;
    }

    toggleTnCModal = () => {
        const { displayPassportTnc } = this.state;
        this.setState({
            displayPassportTnc: !displayPassportTnc,
        });
    }

    disablePassportFeature = () => {
        const {
            featureFlags, bannerOnPage, isPassportBundleProduct, isInPassportHoldout, userProfile,
        } = this.props;
        const userType = userProfile?.userType || '';
        const FLAG_ENABLE_PASSPORT_BANNER_PRODUCT = featureFlags['is-product-passport-banner-enabled'];
        const FLAG_ENABLE_PASSPORT_BANNER_PAYMENT = featureFlags['is-payment-passport-banner-enabled'];
        const FLAG_ENABLE_PASSPORT_BANNER_FLORAL_PAYMENT = featureFlags['which-floral-payment-passport-banner-enabled'];
        const FLAG_ENABLE_PASSPORT = featureFlags['is-passport-enabled'];
        const hasEnrollmentConfig = Object.prototype.hasOwnProperty.call(featureFlags, 'is-celebrations-passport-enrollment-active-ft');

        // brand wide disable passport
        if (FLAG_ENABLE_PASSPORT === false) return true;

        // product page
        if (!hasEnrollmentConfig && FLAG_ENABLE_PASSPORT_BANNER_PRODUCT === false
            && bannerOnPage === 'product') {
            if (isPassportBundleProduct?.details?.bundle_details?.pdpage_message) {
                return false;
            }
            return true;
        }

        // checkout
        if (!hasEnrollmentConfig && FLAG_ENABLE_PASSPORT_BANNER_PAYMENT === false
            && bannerOnPage === 'payment') {
            return true;
        }
        // floral checkout
        if (!hasEnrollmentConfig && FLAG_ENABLE_PASSPORT_BANNER_FLORAL_PAYMENT === 'VARIANT A'
            && bannerOnPage === 'payment-floral') {
            return true;
        }

        // passport holdout group
        if (isInPassportHoldout && userType === 'G') return false;

        if (isInPassportHoldout) return true;

        return false;
    }

    checkPassportCapPrice = () => {
        const { featureFlags, isPassportCapPriceReached } = this.props;
        const FLAG_ENABLE_CHECK_PASSPORT_CAP_PRICE_REACHED = featureFlags['is-passport-cap-price-check-enabled'];
        if (FLAG_ENABLE_CHECK_PASSPORT_CAP_PRICE_REACHED === false) return true;
        if (FLAG_ENABLE_CHECK_PASSPORT_CAP_PRICE_REACHED === true && !isPassportCapPriceReached) return true;
        if (FLAG_ENABLE_CHECK_PASSPORT_CAP_PRICE_REACHED === true && isPassportCapPriceReached) return false;
        return true;
    }

    toggleLearnMoreModal = () => {
        const { displayLearnMore } = this.state;
        this.setState({
            displayLearnMore: !displayLearnMore,
        });
    }

    renderPassportUser = () => {
        const {
            classes, bannerOnPage, passportData, passportSignInData, pdpMessageMember, featureFlags,
        } = this.props;
        const { passport_messaging } = passportData;
        let checkPassportMessage = false;
        let passportMessageText = '';
        const newSubscriptionsExp = featureFlags['is-subscription-exp-enabled'] && bannerOnPage === 'subscriptionsExp';
        if (passport_messaging?.enable_member_message && passport_messaging?.member_message !== null) {
            checkPassportMessage = true;
            passportMessageText = passport_messaging.member_message;
        }
        if (passportSignInData?.productPageMessage) {
            checkPassportMessage = true;
            passportMessageText = passportSignInData.productPageMessage;
        }
        if (pdpMessageMember) {
            checkPassportMessage = true;
            passportMessageText = pdpMessageMember;
        }
        return (
            <div className={classes.passPortCard} style={{ padding: newSubscriptionsExp && 0 }} data-testid="passportBanner">
                <Grid container spacing={0} style={{ alignItems: 'center', justifyContent: newSubscriptionsExp && 'space-between' }}>
                    <Grid xs={1} item className={classes.checkWrapper}>
                        <svg
                            className={classes.checkmark}
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 52 52"
                        >
                            <circle className={classes.checkmarkCircle} cx="26" cy="26" r="25" fill="none" />
                            <path className={classes.checkmarkCheck} fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                        </svg>
                    </Grid>
                    {(newSubscriptionsExp || bannerOnPage === 'product')
                        && (
                            <Grid xs={10} item>
                                <InputLabel className={classes.passportDesc} style={{ marginTop: 0 }}>
                                    {
                                        checkPassportMessage
                                            ? ReactHtmlParser(passportMessageText)
                                            : (
                                                <>Welcome, Passport Valued Member! Enjoy Free Shipping/No Service Charge on today{ReactHtmlParser('&apos;')}s order!</>
                                            )
                                    }
                                </InputLabel>
                            </Grid>
                        )}
                    {(bannerOnPage === 'payment' || bannerOnPage === 'payment-floral')
                        && (
                            <Grid xs={10} item>
                                <InputLabel className={classes.passportDesc}><b>Celebration passport<sup>{ReactHtmlParser('&reg;')}</sup></b> discount has been applied to your cart.</InputLabel>
                            </Grid>
                        )}
                </Grid>
            </div>
        );
    }

    renderPassportUserFood = (memberImg, memberTitle) => {
        const { classes, bannerOnPage } = this.props;
        return (
            <div>
                {bannerOnPage === 'product'
                    && (
                        <Grid xs={10} item>
                            <div>
                                <img src={memberImg} alt={memberTitle} className={classes.passportMemberImage} />
                            </div>
                        </Grid>
                    )}
            </div>
        );
    };

    togglePassport = () => {
        const {
            location: { search }, passportData, passportSignInData, cartData, featureFlags, product,
        } = this.props;
        const productSkus = product?.productSkus;
        if (passportSignInData?.hideAtCheckout && cartData) {
            const { shippingValue = 0, itemsInCart = 0 } = passportSignInData.hideAtCheckout;
            const { orderSize = 0, totalShipping = 0 } = cartData;
            if (shippingValue !== null && shippingValue !== 0 && shippingValue < totalShipping) {
                this.setState({
                    displayPassport: false,
                });
            }
            if (itemsInCart !== null && itemsInCart !== 0 && itemsInCart < orderSize) {
                this.setState({
                    displayPassport: false,
                });
            }
        }
        if (productSkus && featureFlags['disable-pdp-passport-banner']) {
            /*
                Filter product SKUs based on pricing preferences.
                Prioritize 'sale' prices over 'retail' prices.
                Calculate the minimum price among SKUs.
                Hide the passport if the minimum price is less than or equal to the conditional price.
                Pricing Logic:
                - Prefer 'sale' prices when available.
                - If no 'sale' price is found, use 'retail' prices.
                - If neither exists, use null as the default.
            */
            const priceArray = productSkus?.map((item) => item.prices.reduce((preferredPrice, price) => {
                if (price.type === 'sale') {
                    return price.value;
                } if (price.type === 'retail' && preferredPrice === null) {
                    return price.value;
                }
                return preferredPrice;
            }, null));
            const maximumPrice = Math.max.apply(null, priceArray);
            const conditionalPrice = passportData.passport_conditional_logic?.pdp_price || passportData?.price;
            const isPriceUnderConditional = maximumPrice && conditionalPrice && maximumPrice <= conditionalPrice;
            if (isPriceUnderConditional) this.setState({ displayPassport: false });
        }

        if (featureFlags['is-passport-enabled-at-checkout-cms-logic']
            && passportData?.passport_up_sell_conditional_logic
            && cartData) {
            const {
                items_in_cart = 0,
                shipping_service_fee_value = 0,
                number_of_recipients = 0,
            } = passportData.passport_up_sell_conditional_logic;
            const { orderSize = 0, totalShipping = 0, recipients = {} } = cartData;
            if (items_in_cart !== null && items_in_cart !== 0 && orderSize !== 0 && items_in_cart > orderSize) {
                this.setState({
                    displayPassport: false,
                });
            }
            if (shipping_service_fee_value !== null && shipping_service_fee_value !== 0 && shipping_service_fee_value > totalShipping) {
                this.setState({
                    displayPassport: false,
                });
            }
            if (number_of_recipients !== null && number_of_recipients !== 0 && number_of_recipients > recipients.length) {
                this.setState({
                    displayPassport: false,
                });
            }
        }
        if (search) {
            const url = search.match('(utm_param)=([^&]+)');
            if (url && url.length > 1 && url[1] === 'utm_param') {
                if (passportData.passport_up_sell_conditional_logic_at_entrance) {
                    const { utm_param, enable } = passportData.passport_up_sell_conditional_logic_at_entrance;
                    if (enable) {
                        if (url[2] === utm_param) {
                            this.setState({
                                displayPassport: false,
                            });
                        }
                    }
                }
            }
        }
    }

    shouldDisplayPassport = () => {
        const {
            recipientAddress,
            styleForConfirmation,
            cartCount,
            orderTotalSummary: { totalShipping },
            passportBundleItemInCart,
            passportData,
            isPassportUser,
        } = this.props;

        if (!styleForConfirmation
            && !isPassportUser
            && !passportBundleItemInCart) {
            // checking weather we are getting the logic from contentstack
            if (!passportData?.passport_up_sell_conditional_logic) {
                return true;
            }
            const {
                items_in_cart,
                shipping_service_fee_value,
                number_of_recipients,
            } = passportData.passport_up_sell_conditional_logic;

            const cart = () => {
                if (items_in_cart === null || (cartCount < items_in_cart)) {
                    return true;
                } return false;
            };
            const recipient = () => {
                if (number_of_recipients === null || (recipientAddress.length < number_of_recipients)) {
                    return true;
                } return false;
            };
            const shipping = () => {
                if (shipping_service_fee_value === null || (parseInt(totalShipping, 10) < shipping_service_fee_value)) {
                    return true;
                } return false;
            };
            if (cart() === true && recipient() === true && shipping() === true) return true;
        }
        return false;
    }

    specialCaseShouldRender = () => {
        const {
            product,
            featureFlags,
            invokedFrom,
            location,
            passportBundleItemInCart,
            isPassportBundleItem,
            hide18FCheckbox,
            pageType,
        } = this.props;

        if (invokedFrom === 'StandardProductsPage'
            && !isPassportBundleItem
            && !passportBundleItemInCart
            && !hide18FCheckbox
            && !location.pathname.includes('subscription')
            && product.isPassportEligible) {
            return true;
        }

        if (invokedFrom === 'OrderSummary'
            && !passportBundleItemInCart
            && ((featureFlags['is-estimated-shipping-enabled-pwa'] && (pageType === 'cart' || pageType === 'shipping'))
                || (pageType !== 'cart' && pageType !== 'shipping'))) {
            return true;
        }

        // display passport banner for new subscriptions exp page
        if (invokedFrom === 'subscriptionsExp') return true;

        return false;
    }

    render() {
        const {
            classes,
            invokedFrom,
            presentationFamily,
            passportOptIn,
            showApplyPassportRmGCModal,
            bannerOnPage,
            pageType,
            isPaymentMethodAllowedPassportPurchase,
            isPassportUser,
            passportData,
            isPassportBundleProduct,
            passportSignInData,
            featureFlags,
            pdpMessage,
            showPriceNonMembers,
            isPdpRedesignEnabled,
            isPdpRedesignShortEnabled,
            passportThresholdVariant,
            isPlaRedesignEnabled,
            device,
        } = this.props;
        const { displayPassportTnc, displayLearnMore, displayPassport } = this.state;
        const hasEnrollmentConfig = Object.prototype.hasOwnProperty.call(featureFlags, 'is-celebrations-passport-enrollment-active-ft');
        let pageForEnrollment = this.props.enrollmentPage || bannerOnPage;
        if (!this.props.enrollmentPage && pageType === 'cart') pageForEnrollment = 'cart';
        if (!this.props.enrollmentPage && (pageType === 'shipping' || pageType === 'delivery' || pageType === 'recipient')) pageForEnrollment = 'recipient';
        const isEnrollmentActive = !hasEnrollmentConfig || isPassportEnrollmentActive(featureFlags, pageForEnrollment);
        if (hasEnrollmentConfig && !isEnrollmentActive) return null;
        const isMobile = device === 'mobile';
        const hidePassportPdpOnDesktop = !featureFlags['is-product-passport-banner-desktop-enabled'] && !isMobile;  // flag for hide pdp passport widget on desktop
        const hidePassportPdpOnMobile = !featureFlags['is-product-passport-banner-mobile-enabled'] && isMobile;  // flag for hide pdp passport widget on mobile
        // Enable / Disable - Passport Feature Flag
        if (this.disablePassportFeature()) return null;
        // Enable / Disable - Passport UTM Param from ContentStack
        if (!hasEnrollmentConfig && displayPassport === false) return null;
        // flag from contentstack to show/hide passport banner on PDP Page
        const disable_passport_enrolment = passportData?.passport_up_sell_conditional_logic_at_entrance?.disable_passport_enrolment;
        if (!hasEnrollmentConfig && bannerOnPage === 'product' && disable_passport_enrolment) {
            return null;
        }
        if (invokedFrom && !this.specialCaseShouldRender()) {
            return null;
        }

        let pdpReskinStyle = '';
        if (isPdpRedesignShortEnabled) {
            pdpReskinStyle = `${classes.passportContainer} ${classes.pdpShortStyle}`;
        } else if (isPdpRedesignEnabled) {
            pdpReskinStyle = classes.passportContainer;
        }
        const classPaperRoot = (bannerOnPage === 'product' || bannerOnPage === 'payment-floral') ? classes.root : classes.rootPay;

        const isFoodBrand = presentationFamily === 'food';

        const passportActiveMember = () => {
            if (passportSignInData?.type === 'expiringPassportMembership'
                && (passportSignInData?.productPageMessage)) return false;
            if (isPassportUser) return true;
            return false;
        };

        if (!hasEnrollmentConfig
            && bannerOnPage === 'product'
            && !passportActiveMember()
            && (hidePassportPdpOnDesktop || hidePassportPdpOnMobile)) {
            return null;
        }

        let rootClass = '';
        if (passportActiveMember() && isFoodBrand) {
            rootClass = `${classPaperRoot} ${classes.rootFoodPassportMember}`;
            if (bannerOnPage === 'product') {
                rootClass = `${classPaperRoot}`;
            }
            if (bannerOnPage === 'payment' || bannerOnPage === 'payment-floral') {
                rootClass = `${classPaperRoot} ${classes.rootFoodPassportPayment}`;
            }
        } else if (isFoodBrand) {
            rootClass = `${classPaperRoot} ${classes.rootFood}`;
            if (bannerOnPage === 'payment') {
                rootClass = `${classPaperRoot} ${classes.rootFoodPassportPayment}`;
            }
        } else {
            rootClass = classPaperRoot;
        }

        return (
            <div className={`${classes.passportBanner} ${pdpReskinStyle} ${this.props.pdpAtcModule ? classes.pdpAtcModuleContainer : ''} ${isPlaRedesignEnabled ? classes.plaWrapperReskin : ''}`}>
                <Paper
                    id="passport-banner-section"
                    elevation={1}
                    className={(featureFlags['is-pdp-quantity-input-shown'] ? rootClass : `${rootClass} ${classes.marginBottom}`)}
                >
                    {
                        /* Show Message passport user in Floral and Food brand */
                        passportActiveMember() && this.renderPassportUser()
                    }
                    {
                        /* Show Modal warning Add Passport and Remove Gift Card */
                        showApplyPassportRmGCModal && <AddPassportConsent />
                    }
                    {
                        /* Show Modal Terms and Conditions */
                        displayPassportTnc
                        && (
                            <PassportTncModal
                                dialogOpen={displayPassportTnc}
                                closeModal={this.toggleTnCModal}
                            />
                        )
                    }
                    {
                        /* Show Modal Learn More about Passport */
                        displayLearnMore
                        && (
                            <PassportLearnMoreModal
                                learnMoreModalStatus={displayLearnMore}
                                handleModalClose={this.toggleLearnMoreModal}
                                bannerOnPage={bannerOnPage}
                            />
                        )
                    }
                    {
                        /*
                            No passport user and according to the page restriction it will render
                            passport card with the checkbox
                        */
                        (
                            isEnrollmentActive && !passportActiveMember()
                            && (
                                (
                                    bannerOnPage === 'payment'
                                    && isPaymentMethodAllowedPassportPurchase
                                    && this.checkPassportCapPrice()
                                )
                                || (
                                    bannerOnPage === 'payment-floral'
                                    && isPaymentMethodAllowedPassportPurchase
                                    && this.checkPassportCapPrice()
                                )
                                || (
                                    ['product', 'subscriptionsExp'].includes(bannerOnPage)
                                    && this.getEligibleProduct())
                            )
                        )
                        && <PassportCardWithCheckbox pdpMessage={pdpMessage} pdpAtcModule={this.props.pdpAtcModule} showPriceNonMembers={showPriceNonMembers} presentation_family={presentationFamily} bannerOnPage={bannerOnPage} isPassportBundleProduct={isPassportBundleProduct || {}} isPdpRedesignEnabled={isPdpRedesignEnabled} isPdpRedesignShortEnabled={isPdpRedesignShortEnabled} passportThresholdVariant={passportThresholdVariant} isPlaRedesignEnabled={isPlaRedesignEnabled} />
                    }
                </Paper>
            </div>
        );
    }
}

PassportBannerUI.propTypes = {
    classes: object.isRequired,
    invokedFrom: string,
    passportOptIn: bool.isRequired,
    product: object,
    isPaymentMethodAllowedPassportPurchase: bool.isRequired,
    passportBundleItemInCart: bool.isRequired,
    isPassportUser: bool.isRequired,
    featureFlags: object,
    showApplyPassportRmGCModal: bool.isRequired,
    bannerOnPage: string.isRequired,
    isPassportCapPriceReached: bool.isRequired,
    productsById: object,
    selectedProductSku: string,
    callClearErrors: func.isRequired,
    presentationFamily: string.isRequired,
    pageType: string,
    enrollmentPage: string,
    fetchUserProfile: func.isRequired,
    location: object.isRequired,
    passportData: shape({
        passport_up_sell_conditional_logic_at_entrance: shape({
            enable: bool,
            utm_param: string,
        }),
        passport_messaging: shape({
            enable_member_message: bool,
            member_message: string,
        }),
    }),
    isPassportBundleProduct: shape({
        prices: {
            value: number,
        },
        enable: bool,
    }),
    hide18FCheckbox: bool.isRequired,
    isPassportBundleItem: bool.isRequired,
    passportSignInData: shape({
        enable: bool,
        price: number,
        itemSku: string,
        hideAtCheckout: shape({
            shippingValue: number,
            itemsInCart: number,
        }),
        passportEnrolmentTerm: string,
        checkoutPageMessage: string,
        productPageMessage: string,
    }),
    cartData: shape({
        orderSize: number,
        totalShipping: string,
    }),
    cartCount: number,
    recipientAddress: array,
    orderTotalSummary: object,
    styleForConfirmation: bool,
    pdpMessage: string,
    pdpAtcModule: object,
    pdpMessageMember: string,
    isInPassportHoldout: bool,
    userProfile: object,
    history: shape({
        go: func,
    }),
    showPriceNonMembers: bool,
    isPdpRedesignEnabled: bool,
    isPdpRedesignShortEnabled: bool,
    passportThresholdVariant: bool,
    isPlaRedesignEnabled: bool,
    device: string,
};

PassportBannerUI.defaultProps = {
    invokedFrom: '',
    pageType: '',
    enrollmentPage: '',
    product: {},
    cartCount: 0,
    recipientAddress: [],
    orderTotalSummary: {},
    styleForConfirmation: false,
    featureFlags: {},
    productsById: {},
    selectedProductSku: '',
    passportData: {},
    isPassportBundleProduct: {},
    passportSignInData: {},
    cartData: {},
    pdpMessage: null,
    pdpAtcModule: null,
    pdpMessageMember: null,
    isInPassportHoldout: false,
    userProfile: {},
    history: {},
    showPriceNonMembers: false,
    isPdpRedesignEnabled: false,
    isPdpRedesignShortEnabled: false,
    passportThresholdVariant: false,
    isPlaRedesignEnabled: false,
    device: '',
};

const getProductsById = function getProductsById(state) {
    if (state && state.catalog && state.catalog.products && state.catalog.products.byId) {
        return state.catalog.products.byId;
    }
    return null;
};

const getSelectedProductSku = function getSelectedProductSku(state) {
    if (state && state.ui && state.ui.pdpCart && state.ui.pdpCart.selectedSKUProduct) {
        return state.ui.pdpCart.selectedSKUProduct;
    }
    return null;
};

const mapStateToProps = (state) => ({
    passportOptIn: getPassportSubscriptionStatus(state),
    isPaymentMethodAllowedPassportPurchase: getPassportBannerStatus(state),
    isPassportUser: getIsPassportUserLoggedIn(state),
    featureFlags: getFeatureFlags(state),
    showApplyPassportRmGCModal: getStatusOfPassportApplyRmGC(state),
    isPassportCapPriceReached: getIsPassportCapPriceReached(state),
    passportBundleItemInCart: getPassportBundleItemCurrentlyInCart(state),
    presentationFamily: getPresentationFamily(state),
    productsById: getProductsById(state),
    selectedProductSku: getSelectedProductSku(state),
    passportData: getPassportData(state),
    passportSignInData: getPassportSignInData(state),
    cartData: getCartOrderDetails(state),
    orderContainsSubscriptionItem: getOrderContainsSubscriptionItem(state),
    cartCount: getCartCount(state),
    recipientAddress: getRecipientAddress(state),
    orderTotalSummary: getOrderTotalSummary(state),
    isInPassportHoldout: getPassportHoldoutStatus(state),
    userProfile: getUserProfile(state),
    device: getSSRDeviceType(state),
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(tagManagerActions.trackEvent, dispatch),
    callClearErrors: bindActionCreators(clearErrors, dispatch),
    fetchUserProfile: () => dispatch(EventDispatcher.fetchUserProfile()),
});

const enhance = compose(
    withRouter,
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps),
);

export default enhance(PassportBannerUI);
